import { newId } from './ids.ts';
import { tr, type Locale } from './locale.ts';
import type { Project, Sheet, Standard } from './types.ts';

export const CURRENT_FORMAT_VERSION = 10;

export function createProject(init: { title?: string; locale?: Locale; standard?: Standard } = {}): Project {
  const sheet: Sheet = {
    id: newId(),
    name: tr(
      init.locale ?? 'fr',
      'Schéma unifilaire',
      'Single-line diagram',
      'Eendraadschema',
      'Einliniendiagramm',
    ),
    kind: 'single-line',
    paper: 'A4',
    orientation: 'landscape',
    order: 0,
  };
  return {
    formatVersion: CURRENT_FORMAT_VERSION,
    id: newId(),
    meta: {
      title: init.title ?? '',
      ownerName: '',
      ownerAddress: '',
      installationAddress: '',
      author: '',
      date: new Date().toISOString().slice(0, 10),
      earthingSystem: 'TT',
      supplyVoltage: '230 V',
      company: '',
      locale: init.locale ?? 'fr',
      standard: init.standard ?? 'rgie',
    },
    sheets: { [sheet.id]: sheet },
    elements: {},
    wires: {},
    circuits: {},
    revisions: {},
    symbols: {},
    surveyRooms: {},
    surveyPoints: {},
    surveyBoards: {},
    surveyCircuits: {},
    measurements: {},
    inspections: {},
    remarks: {},
    invoices: {},
    signoffs: {},
  };
}

export function sheetsInOrder(project: Project): Sheet[] {
  return Object.values(project.sheets).sort((a, b) => a.order - b.order);
}
